import React, { useState, useEffect } from 'react';
import { Typeahead, withAsync } from 'react-bootstrap-typeahead';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const AsyncTypeahead = withAsync(Typeahead);

async function getAddressOptions(term) {
  try {
    const url =
      'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates';
    const res = await axios.get(
      `${url}?category=Address,Postal&maxLocations=6&distance=539130&location=-112.053569,33.490526&f=json&singleLine=${term}`
    );
    if (res.data && res.data.candidates && res.data.candidates.length > 0) {
      return res.data.candidates.map((candidate) => {
        return { ...candidate, id: uuidv4() };
      });
    }
    return res;
  } catch (error) {
    console.log(error);
    return;
  }
}

export default function AddressTypeahead({
  onChange,
  field,
  placeholder,
  id,
  width,
  ml,
  required
}) {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div>
      <AsyncTypeahead
        isLoading={isLoading}
        labelKey='address'
        id='1'
        filterBy={(test) => true}
        onSearch={(query) => {
          (async () => {
            if (query.length > 4) {
              setIsLoading(true);
              const addressCandidates = await getAddressOptions(query);
              setOptions(() => addressCandidates);
              setIsLoading(false);
            }
          })();
        }}
        options={options}
        onChange={onChange}
      />
    </div>
  );
}
